




























import { defineComponent } from '@vue/composition-api';
import QuestionTooltip from '@/components/common/question-tooltip/index.vue';

const name = 'ttam-audience-size-impression-tip';
export default defineComponent({
  components: {
    QuestionTooltip,
  },
  props: {
    label: {
      type: String,
    },
    buttonLabel: {
      type: String,
    },
    isHint: {
      type: Boolean,
    },
  },
  setup(props, { emit }) {
    const btnClick = () => {
      emit('btnClick');
    };
    return {
      name,
      btnClick,
    };
  },
});
